import { AGGREGATE_NAMES, TEMPLATE_RESOLVERS } from 'cpool-constants';
import { schemaTemplateResolver_GetMailTemplates } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';

export const useMailTemplates = () => {
    return useAggregateQuery({
        acl: {},
        aggregateName: AGGREGATE_NAMES.TEMPLATE,
        resolverName: TEMPLATE_RESOLVERS.getMailTemplates,
        schema: schemaTemplateResolver_GetMailTemplates,
    });
};
